import { ExpandSearch, Notification } from "components/common";
import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import "./RoughTimekeeping.scss";
import { setButtonsHeader, setSiderKey } from "redux/reducer/common";
import { allColumns, itemsInputField } from "./RoughTimekeeping.config";
import {
  Button,
  Form,
  Pagination,
  Row,
  Space,
  TimePicker,
  Upload,
  UploadProps,
} from "antd";
import {
  checkEmptyObj,
  isApproveRecord,
  saveTableOptions,
} from "helper/common";

import { UploadOutlined } from "@ant-design/icons";
import { employeeService } from "api";
import dayjs from "dayjs";

import { EmptySVG } from "assets";

import { FORMAT_TIME } from "types/enums";
import usePermission from "hooks/usePermission";
import ExpandSearchHCNS from "components/common/ExpandSearch/ExpandSearchHCNS";

const RoughTimekeeping: React.FC = () => {
  const { isNhanVien, isQuanLy, isGiamDoc } = usePermission();
  const expandRef = useRef(null);
  const dispatch = useAppDispatch();
  const [columns, setColumns] = useState(null);
  const [roww,setRow] =useState(null);
  // allColumns.find((e) => e.dataIndex === "stt").render = (
  //   text,
  //   record,
  //   index
  // ) => {
  //   const rowNumber = (currentPage - 1) * params.limit + index + 1;
  //   setRow(rowNumber)
  //   return rowNumber;

  // };
 // const [sttMap, setSttMap] = useState({}); // Số thứ tự tương ứng với mỗi maNhanVien

  const [total, setTotal] = useState(12);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  //lấy ra tháng và năm hiện tại
  const today = new Date();
  const employees = useAppSelector((state) => state.employeesReducer);
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const [currentPage, setCurrentPage] = useState(1);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    nam: currentYear,
    thang: currentMonth,
  });
  useEffect(() => {
    dispatch(setSiderKey("chamCongTho"));
  }, []);
  useEffect(() => {
    setOptionsPBFields(employees.phongBanList, "idPhongBan");
  }, [employees.phongBanList]);
  const setOptionsPBFields = (list, tenPhongBan) => {
    if (itemsInputField.find((field) => field.name === tenPhongBan)) {
      itemsInputField.find((field) => field.name === tenPhongBan).options =
        list?.map((item) => ({
          value: item.id,
          label: item.tenPhongBan,
        }));
    }
  };
  const [data, setData] = useState<any[]>();
  // useEffect(() => {
  //   setSttMap({}); // Đảm bảo sttMap được reset khi data thay đổi
  //   data && data.forEach((e, index) => {
  //     setSttMap(prevMap => ({
  //       ...prevMap,
  //       [e.maNhanVien]: (params.page - 1) * params.limit + index + 1
  //     }));
  //   });
  // }, [data]); // useEffect sẽ chạy mỗi khi data thay đổi
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  const onSearch = async () => {
    setCurrentPage(1);
    var searchFields = expandRef?.current?.getData();
    setParams({ ...params, ...searchFields, page: 1 }); // Đặt trang về 1 khi thực hiện tìm kiếm
  };
  useEffect(() => {
    expandRef?.current.setFieldValue("nam", currentYear);
    expandRef?.current.setFieldValue("thang", currentMonth);
  }, []);
  function getAllDatesInMonth(year, month) {
    const startDate = new Date(year, month - 2, 21); // month is 0-indexed
    const endDate = new Date(year, month - 1, 20);
    const dates = [];
    while (startDate <= endDate) {
      dates.push(new Date(startDate)); // clone the date object
      startDate.setDate(startDate.getDate() + 1);
    }

    return dates;
  }
  const nam = params.nam;
  const thang = params.thang;
  // khi tháng này thay đổi thì component sẽ đc render lại -> nó sẽ kiểm tra điều kiện trong useEffec này
  // useEffect(() => {
  //   // Lấy ngày từ tháng trc tới tháng sau
  //   const datesInFebruary2023 = getAllDatesInMonth(nam, thang);
  //   const dateOfMonth = [];
  //   datesInFebruary2023.map((e) => {
  //     //Check ngày trong tuần
  //     dateOfMonth.push({
  //       title: `${e.getDate()}/${e.getMonth()+ 1}/${e.getFullYear()}`,
  //       align: "center",
  //       width: "80px",
  //       day: e.getDate(),
  //     });
  //   });
  //   setColumns(dateOfMonth);
  // }, [nam, thang]);
  useEffect(() => {
    // Lấy ngày từ tháng trc tới tháng sau
    const datesInFebruary2023 = getAllDatesInMonth(nam, thang);
    const dateOfMonth = [];

    datesInFebruary2023.map((e) => {
      //Check ngày trong tuần
      const dayOfWeek = e.getDay();
      const dayOfWeekText =
        dayOfWeek === 0
          ? "CN"
          : dayOfWeek === 1
          ? "T2"
          : dayOfWeek === 2
          ? "T3"
          : dayOfWeek === 3
          ? "T4"
          : dayOfWeek === 4
          ? "T5"
          : dayOfWeek === 5
          ? "T6"
          : dayOfWeek === 6
          ? "T7"
          : "";

      dateOfMonth.push({
        title: `${e.getDate()}/${e.getMonth() + 1}/${e.getFullYear()}`,
        align: "center",
        width: "120px", // Adjust the width as needed
        day: e.getDate(),
        dayOfWeekText: dayOfWeekText,
      });
    });
    setColumns(dateOfMonth);
  }, [nam, thang]);

  const rows = [
    { value: 0, isShow: true },
    { value: 1, isShow: false },
    { value: 2, isShow: false },
  ];
  const handleSubmit = async () => {
    setLoading(true);
    const formData = form.getFieldsValue();

    try {
      const datas = Object.keys(formData).map((key) => {
        const item = formData[key];
        const formattedItem = { ...item };

        const numberOfDays = Object.keys(formattedItem).filter((key) =>
          key.startsWith("day")
        ).length;

        for (let day = 1; day <= numberOfDays; day++) {
          for (let row = 1; row <= 3; row++) {
            if (formattedItem[`day${day}`]) {
              formattedItem[`day${day}`][`gioVao${row}`] = formattedItem[
                `day${day}`
              ][`gioVao${row}`]
                ? formattedItem[`day${day}`][`gioVao${row}`].format(
                    FORMAT_TIME.time_24h_mili
                  )
                : null;

              formattedItem[`day${day}`][`gioRa${row}`] = formattedItem[
                `day${day}`
              ][`gioRa${row}`]
                ? formattedItem[`day${day}`][`gioRa${row}`].format(
                    FORMAT_TIME.time_24h_mili
                  )
                : null;
            }
          }
        }

        return formattedItem;
      });

      const res = await employeeService.updateRoughtTimekeeping(datas);
      getListRoughtTImekeeping(params);
      Notification("success", "Cập nhập thành công ");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Cập nhập thất bại");
    }
  };

  useEffect(() => {
    getListRoughtTImekeeping(params);
  }, [params]);

  const onShowSizeChange = (page: number, pageSize: number) => {
    setParams({ ...params, page: page, limit: pageSize });
  };

  const props: UploadProps = {
    beforeUpload: (file) => {
      const isXLSX =
        file.name.endsWith(".xlsx") ||
        file.name.endsWith(".xls") ||
        file.name.endsWith(".xlsm") ||
        file.name.endsWith(".xlt");

      if (!isXLSX) {
        Notification("error", `${file.name} không phải là file excel`);
      }
      return isXLSX || Upload.LIST_IGNORE;
    },
    customRequest: async (options) => {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("files", options.file);
        const res = await employeeService.importRoughtTimekeeping(formData);
        if (res.data.length > 0) {
          // Lặp qua từng đối tượng trong mảng
          res.data.forEach((item) => {
            // Kiểm tra xem đối tượng có thuộc tính 'errors' không
            if (item.hasOwnProperty("errors")) {
              // Log giá trị của 'errors'
              Notification("warning", `${item.errors}`);
            }
          });
        }
        if (res.type === "ERROR") {
          Notification("error", res.message);
        } else {
          Notification(
            "success",
            `Tải lên danh sách ${options.file["name"]} thành công`
          );
        }
        await getListRoughtTImekeeping(params);
        setLoading(false);
      } catch (error) {
        Notification(
          "error",
          `Tải lên danh sách ${options.file["name"]} không thành công`
        );
        setLoading(false);
      }
    },
    maxCount: 1,
    showUploadList: false,
  };

  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "RECEIVED_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const browseListRoughtTImekeeping = async () => {
    setLoading(true);
    try {
      const res = await employeeService.browseRoughtTimekeeping(params);
      Notification("success", "Đã duyệt chấm công thô thành công");
      getListRoughtTImekeeping(params);
      setLoading(false);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi duyệt chấm công thô");
      setLoading(false);
    }
  };
  const getListRoughtTImekeeping = async (value) => {
    try {
      const res = await employeeService.getListRoughtTImekeeping(value);

      if (!checkEmptyObj(res.data.items)) {
        const dataTable = res.data.items;
        const formatData = () => {
          return dataTable.map((item, index) => {
            if (typeof item !== "object") {
              return item;
            }

            const formattedItem = { ...item };
            //console.log(formattedItem.length);
            const numberOfDays = Object.keys(formattedItem).filter((key) =>
              key.startsWith("day")
            ).length;
            for (let day = 1; day <= numberOfDays; day++) {
              for (let row = 1; row <= 3; row++) {
                if (formattedItem[`day${day}`]) {
                  formattedItem[`day${day}`][`gioVao${row}`] = formattedItem[
                    `day${day}`
                  ][`gioVao${row}`]
                    ? dayjs(
                        formattedItem[`day${day}`][`gioVao${row}`],
                        FORMAT_TIME.time_24h
                      )
                    : null;

                  formattedItem[`day${day}`][`gioRa${row}`] = formattedItem[
                    `day${day}`
                  ][`gioRa${row}`]
                    ? dayjs(
                        formattedItem[`day${day}`][`gioRa${row}`],
                        FORMAT_TIME.time_24h
                      )
                    : null;
                }
              }
            }

            return formattedItem;
          });
        };

        const formattedData = formatData();
        form.setFieldsValue(formattedData);
        setData(formattedData);
      } else setData(null);

      setTotal(res.data.total);
    } catch (error) {
      Notification("error", "Lấy danh sách chấm công thô không thành công");
    }
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  return (
    <div className="rought-timekeeping page">
      <div className="main">
        <div className="container" onKeyDown={onKeyDown}>
          <ExpandSearchHCNS
            onClickSearch={onSearch}
            fields={itemsInputField}
            isSearchExpend={false}
            isResetField={false}
            ref={expandRef}
            initialValues={params}
          />
        </div>
        <div className="container">
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row justify={"end"}>
              <Space
                style={{
                  // width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  //justifyContent: "end",
                }}
              >
                <Upload
                  {...props}
                  disabled={isNhanVien() || isQuanLy() || isGiamDoc()}
                >
                  <Button
                    className="btn-sub"
                    type="primary"
                    icon={<UploadOutlined rev={0} />}
                  >
                    Tải lên
                  </Button>
                </Upload>
                <Button
                  className="btn-sub"
                  type="primary"
                  onClick={browseListRoughtTImekeeping}
                  disabled={isNhanVien() || isQuanLy() || isGiamDoc()}
                >
                  Duyệt bảng chấm công thô
                </Button>
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  disabled={isNhanVien() || isQuanLy() || isGiamDoc()}
                >
                  Lưu lại
                </Button>
              </Space>
            </Row>
            <Form name="datepicker-form" form={form}>
              <div className="tb-wrapper">
                <table
                  className="table-custom"
                  style={{
                    borderRadius: "8px",
                    minHeight: data ? "" : "300px",
                    width: data ? "800vh" : "100%",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        className="th-stt"
                        style={{
                          width: data ? "40px" : "",
                          textAlign: "center",
                          position: "sticky",
                          left: "0", // Đảm bảo nó cố định bên cạnh Mã NV
                          zIndex: 2, // Đảm bảo nó hiển thị dưới STT
                        }}
                      >
                        STT
                      </th>
                      <th
                        className="th-mnv"
                        style={{
                          width: data ? "80px" : "",
                          position: "sticky",
                          left: "100px", // Đảm bảo nó cố định bên cạnh STT
                          zIndex: 1, // Đảm bảo nó hiển thị dưới STT
                        }}
                      >
                        Mã NV
                      </th>
                      <th
                        className="th-name"
                        style={{
                          width: data ? "150px" : "",
                          position: "sticky",
                          left: "200px", // Đảm bảo nó cố định bên cạnh Mã NV
                          zIndex: 0, // Đảm bảo nó hiển thị dưới STT
                        }}
                      >
                        Họ tên
                      </th>
                      {columns &&
                        columns.map((e) => (
                          <th colSpan={data ? 2 : 0}>
                            {e.title}
                            {e.dayOfWeekText && (
                              <div style={{ fontSize: "12px" }}>
                                {e.dayOfWeekText}
                              </div>
                            )}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data ? (
                      data.map((e, indexData) => (
                        <>
                          {columns &&
                            rows.map((row, indexRow) => {
                              return (
                                <>
                                  <tr style={{ display: "none" }}>
                                    <td>
                                      <Form.Item name={[indexData, "id"]} />
                                    </td>
                                  </tr>
                                  <tr key={row.value}>
                                    {row?.isShow && (
                                      <>
                                        <td
                                          rowSpan={3}
                                          style={{
                                            textAlign: "center",
                                            position: "sticky",
                                            left: "0",
                                            zIndex: 2,
                                            backgroundColor: "white",
                                           // borderBottom:"1px solid black"
                                          }}
                                        >
                                          {(params.page - 1) * params.limit + indexData + 1}
                                        </td>
                                        <td
                                          rowSpan={3}
                                          style={{
                                            position: "sticky",
                                            left: "100px",
                                            zIndex: 1,
                                            backgroundColor: "white",
                                          //  borderBottom:"1px solid black"
                                          }}
                                        >
                                          <Form.Item
                                            name={[indexData, "maNhanVien"]}
                                          >
                                            {e.maNhanVien}
                                          </Form.Item>
                                        </td>
                                        <td
                                          rowSpan={3}
                                          style={{
                                            position: "sticky",
                                            left: "200px",
                                            zIndex: 1,
                                            backgroundColor: "white",
                                         //   borderLeft: "1px solid #b9b9b9",
                                          }}
                                        >
                                          <Form.Item
                                            name={[indexData, "hoTen"]}
                                          >
                                            {e.hoTen}
                                          </Form.Item>
                                        </td>
                                      </>
                                    )}
                                    {columns &&
                                      columns.map((column) => {
                                        for (
                                          let index = 0;
                                          index < columns.length;
                                          index++
                                        ) {
                                          return (
                                            <td key={column.day} colSpan={2}>
                                              <tr style={{ border: "none" }}>
                                                <td
                                                  style={{
                                                    width: "130px",
                                                    border: "none",
                                                  }}
                                                >
                                                  <Form.Item
                                                    name={[
                                                      indexData,
                                                      `day${column.day}`,
                                                      `gioVao${indexRow + 1}`,
                                                    ]}
                                                  >
                                                    <TimePicker
                                                      disabled={isApproveRecord(
                                                        data
                                                      )}
                                                      format={
                                                        FORMAT_TIME.time_24h
                                                      }
                                                   //   style={{ backgroundColor: e[`day${column.day}`][`gioVao${indexRow + 1}`] && dayjs(e[`day${column.day}`][`gioVao${indexRow + 1}`], FORMAT_TIME.time_24h).isAfter(dayjs('07:00', FORMAT_TIME.time_24h)) ? 'red' : '' }}
                                                    />
                                                  </Form.Item>
                                                </td>
                                                <td
                                                  style={{
                                                    width: "130px",
                                                    border: "none",
                                                  }}
                                                >
                                                  <Form.Item
                                                    name={[
                                                      indexData,
                                                      `day${column.day}`,
                                                      `gioRa${indexRow + 1}`,
                                                    ]}
                                                  >
                                                    <TimePicker
                                                      disabled={isApproveRecord(
                                                        data
                                                      )}
                                                      format={
                                                        FORMAT_TIME.time_24h
                                                      }
                                                    />
                                                  </Form.Item>
                                                </td>
                                              </tr>
                                            </td>
                                          );
                                        }
                                      })}
                                  </tr>
                                </>
                              );
                            })}
                        </>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={columns?.length + 3}>
                          <div style={{ textAlign: "center" }}>
                            <EmptySVG />
                          </div>
                          <div
                            style={{ textAlign: "center", color: "#00000040" }}
                          >
                            Trống
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {total >= 10 && (
                <div style={{ marginTop: "10px", textAlign: "end" }}>
                  <Pagination
                    defaultCurrent={params.page}
                    onChange={onShowSizeChange}
                    current={params.page}
                    total={total}
                    showSizeChanger={true}
                  />
                </div>
              )}
            </Form>
          </Space>
        </div>
      </div>
    </div>
  );
};
export default RoughTimekeeping;
